import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import videoCover from "../../../../../../../media/images/videoCover.png";
import { Link } from "react-router-dom";
import ArrowTickLeft from "../../../../../../../media/images/icons/arrow-tick-left";
export default function VideoCard() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        boxShadow: "0px 4px 8px 3px rgba(0,0,0,0.1)",
        borderRadius: "16px",
        minWidth: "270px",
        // border: "1px solid gray",
      }}
    >
      <img
        style={{
          borderRadius: "16px",
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
        src={videoCover}
        alt=""
      />
      <Box
        sx={{
          position: "absolute",
          left: "3px",
          right: "3px",
          padding: "10px 8px",
          bottom: "3px",
          borderRadius: "16px",
          // width: "100%",
          backgroundColor: "white",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
          }}
        >
          آموزش دریافت بار و شرکت در مناقصه که اگر متن طولانی بود
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography
              noWrap
              sx={{
                flex: 1,
                textAlign: "center",
                color: "info.main",
                borderRadius: "4px",
                fontSize: "12px",
                padding: "5px 3px",
                backgroundColor: "info.light",
              }}
            >
              18 ویدئو
            </Typography>
            <Typography
              noWrap
              sx={{
                flex: 1,
                color: "info.main",
                borderRadius: "4px",
                fontSize: "12px",
                padding: "5px 3px",
                backgroundColor: "info.light",
              }}
            >
              544 امتیاز
            </Typography>
          </Box>
          <Link
            to={"#"}
            style={{
              backgroundColor: theme.palette.secondary.main,
              display: "flex",
              alignItems: "center",
              gap: "3px",
              padding: "8px 4px",
              borderRadius: "8px",
            }}
          >
            <Typography noWrap color="#fff">
              مشاهده ادامه
            </Typography>
            <ArrowTickLeft size={18} color="#fff" />
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
